import ValueNode from './ValueNode';
import TextType from './TextType';

export default class NumberNode extends ValueNode<number> {

	public toText (textType = TextType.PLAIN) {
		return this.getValue().toString();
	}

	public normalized () {
		return this;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/NumberNode.ts